export default "__VITE_ASSET__Rtw21Sci__"